<div class="wrapper-config-menu menu">

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header menu-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config   [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config    [device]="device"   [elementChoosing]="objectChoosing" [width]="class['list-order']['width']" [height]="class['list-order']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu0" (nzOpenChange)="openHandler('menu0')">
        <div class="button-size">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>

      <!-- Cấu hình nội dung  -->
      <li nz-submenu nzTitle="{{'cau_hinh_noi_dung'| translate}}">
        <div class="color-pick">
          <span class="title w-50"> {{'mau_nut_chua_chon' | translate}} </span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['-btn-right']['background-color']"
            [style.background]="class['-btn-right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>
        <div class="color-pick">
          <span class="title w-50"> {{'mau_nut_da_chon' | translate}} </span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['+btn-right']['background-color']"
            [style.background]="class['+btn-right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>

        <h2 class="mb-1">Menu</h2>
        <ng-container>
          <h2 class="mb-1">{{'noi_dung_ben_phai_muc_don_mua' | translate}}</h2>
          <!-- title đơn mua -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_don_mua' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase['title_right_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase['title_right_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('title_right', '');"></textarea>
            </mat-form-field>
          </div>
          <!-- Đơn đã đặt -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'tab_don_da_dat' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_placed_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_placed_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('order_placed', 'label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Đơn đã mua -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'tab_don_da_mua' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_purchased_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_purchased_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('order_purchased', 'label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Bạn chưa có đơn hàng nào -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'chua_co_don_hang' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['no_orders_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['no_orders_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('no_orders', 'label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Mã đơn hàng -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'ma_don_hang' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_code_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_code_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('order_code', 'label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Ngày đặt -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'ngay_dat' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_date_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_date_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('order_date', 'label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng tiền -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'tong_tien' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_total_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_total_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('order_total', 'label');"></textarea>
            </mat-form-field>
          </div>
          <!-- title modal chi tiết đơn hàng -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_hop_thoai_thong_tin_don_hang' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail['title_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail['title_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('title', 'modal_detail');"></textarea>
            </mat-form-field>
          </div>
          <!-- nút đóng modal -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'nut_dong_hop_thoai' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['close_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['close_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('close', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- hình ảnh -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_hinh_anh_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['img_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['img_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('img', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- tên sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_ten_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['name_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['name_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('name', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Giá sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_gia_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['price_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['price_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('price', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Số lượng sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_so_luong_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['quantity_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['quantity_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('quantity', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Thành tiền sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_thanh_tien_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['total_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['total_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('total', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng: Tạm tính -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tam_tinh' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['subtotal_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['subtotal_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('subtotal', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng: Tổng tiền -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tong_tien' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['total_price_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['total_price_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('total_price', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng: Phiếu thanh toán -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'phieu_thanh_toan' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['payment_slip_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['payment_slip_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('payment_slip', 'modal_detail.label');"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
      </li>

      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['list-order']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[2])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
    </ul>

  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['list-order']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>
